export interface AppConfig {
  timeout: number;
  PortalImagesPath: string;
  BaseBffUrl : string;
  PortalBaseUrl : string;
}

let defaultConfig : AppConfig = {
  timeout: 5000,
  PortalImagesPath: "",
  BaseBffUrl: "",
  PortalBaseUrl: ""
}

const CONFIG_KEY = '__app_config__';

export const loadConfig = async (): Promise<void> => {
  // Don't re-fetch if HMR re-evaluates this module
  if ((window as any)[CONFIG_KEY]) return;

  const response = await fetch('/config.json');
  const json = await response.json();

  (window as any)[CONFIG_KEY] = json;
};

export const getConfig = (): AppConfig => {
  const config = (window as any)[CONFIG_KEY];
  if (!config) {
    return defaultConfig;
  }
  return config as AppConfig;
};